import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OpenIncidentController } from '@shared/src/controllers/open/openincident.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { HString } from '@shared/src/datatypes/HString';
import { IncidentDto } from '@shared/src/dtos/incident/IncidentDto';
import { IncidentStateDto } from '@shared/src/dtos/incident/IncidentStateDto';
import { IncidentsStructDto } from '@shared/src/dtos/incident/IncidentsStructDto';
import { IncidentTypes } from '@shared/src/enums/IncidentTypes';
import { SharedIncidentAbstractComponent } from '@shared/src/components/route/incident/shared.incident.component.abstract';
import { Observable } from 'rxjs';

/**
 * Permet a un agent extern informar d'un problema (mateixa funcionalitat que la incidència de l'app, amb els
 * endpoints oberts). Només el conductor pot indicar que està parat.
 */
@Component({
    selector: 'shared-external-cmr-agent-incident',
    templateUrl: './shared.external.cmr.agent.incident.component.html',
    styleUrls: ['./shared.external.cmr.agent.incident.component.scss']
})
export class SharedExternalCMRAgentIncidentComponent extends SharedIncidentAbstractComponent implements OnInit {

    constructor(public openIncidentController: OpenIncidentController) {
        super();
    }

    private phaseUUIDValue: string;
    @Input()
    public set phaseUUID(value: string) {
        if (this.phaseUUIDValue === value)
            return;
        this.phaseUUIDValue = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.phaseUUIDValue;
    }

    /** Des de la pantalla d'accions: QR de la ruta (en lloc de la fase) */
    private uuidQRValue: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.uuidQRValue === value)
            return;
        this.uuidQRValue = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.uuidQRValue;
    }

    private agentValue: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.agentValue === value)
            return;
        this.agentValue = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.agentValue;
    }

    /** S'emet en informar del problema (per tornar enrere es fa servir el botó de la barra) */
    @Output() public done: EventEmitter<boolean> = new EventEmitter();

    public state: IncidentStateDto;

    /** Les dades es carreguen quan arriben el UUID i l'agent (loadData) */
    public ngOnInit(): void {
    }

    private isReady(): boolean {
        return RouteCMRAgentsEnum.isValid(this.agent)
            && (!HString.isNullOrNullString(this.phaseUUID) || !HString.isNullOrNullString(this.uuidQR));
    }

    public loadData(): void {
        if (!this.isReady())
            return;
        this.loadIncidentStruct();
        this.openIncidentController.getIncidentState(this.phaseUUID, this.uuidQR, this.agent).subscribe(data => {
            this.state = data;
        });
    }

    public canStandStill(): boolean {
        return this.state != null && this.state.canStandStill;
    }

    /** Es mostra el temps previst si s'indica que s'està parat */
    public getShowStandStillTime(): boolean {
        return this.canStandStill() && (this.standStill
            || (this.incidentSelected != null && this.incidentSelected.incident === IncidentTypes.EstoyParado));
    }

    protected getIncidentStruct(): Observable<IncidentsStructDto> {
        if (!this.isReady())
            return null;
        return this.openIncidentController.getIncidentStruct(this.phaseUUID, this.uuidQR, this.agent);
    }

    protected sendIncident(incident: IncidentDto): Observable<boolean> {
        // La ruta i la fase les determina el backend a partir del UUID
        incident.routeId = null;
        incident.phaseId = null;
        incident.shipmentId = null;
        return this.openIncidentController.reportIncident(this.phaseUUID, this.uuidQR, this.agent, incident);
    }

    protected onIncidentReported(): void {
        this.done.next(true);
    }

    /** La ruta i la fase les determina el backend a partir del UUID; aquí només serveixen per validar */
    protected getRouteId(): number {
        return 0;
    }

    protected getPhaseId(): number {
        return 0;
    }

    protected getShipmentId(): number {
        return null;
    }

}
